// Shared calendar helpers: date maths, colour codes and one normalised event shape for
// bookings, Admin Holds and Availability Blocks.

export const iso = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const addDays = (d, n) => {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
};

export const parseLocal = (s) => new Date(String(s || "").length <= 10 ? `${s}T00:00:00` : s);
export const hhmm = (d) => `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
export const DAY_LABELS = ["Sen", "Sel", "Rab", "Kam", "Jum", "Sab", "Min"];
export const MONTHS = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus",
  "September", "Oktober", "November", "Desember"];

export const monthTitle = (d) => `${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
export const startOfWeek = (d) => addDays(d, -((d.getDay() + 6) % 7));

const TONES = {
  paid: "bg-emerald-50 border-emerald-300 text-emerald-900",
  waiting: "bg-amber-50 border-amber-300 text-amber-900",
  running: "bg-sky-50 border-sky-300 text-sky-900",
  done: "bg-neutral-100 border-neutral-300 text-neutral-600",
  cancelled: "bg-red-50 border-red-200 text-red-700 line-through",
  hold: "bg-violet-50 border-violet-400 border-dashed text-violet-900",
  block: "bg-zinc-200/70 border-zinc-400 text-zinc-800",
};

const BAR = {
  paid: "bg-emerald-400/80", waiting: "bg-amber-400/80", running: "bg-sky-400/80",
  done: "bg-neutral-400/70", cancelled: "bg-red-300/70",
  hold: "bg-violet-400/80", block: "bg-zinc-500/70",
};

export const toneClass = (t) => TONES[t] || TONES.done;
export const barClass = (t) => BAR[t] || BAR.done;

export const LEGEND = [
  { tone: "paid", label: "Sudah dibayar" },
  { tone: "waiting", label: "Menunggu bayar" },
  { tone: "running", label: "Sedang jalan" },
  { tone: "done", label: "Selesai" },
  { tone: "hold", label: "Admin Hold" },
  { tone: "block", label: "Blokir (non-pendapatan)" },
];

const bookingTone = (s) => {
  if (s === "Cancelled") return "cancelled";
  if (["Completed", "Returned", "Inspection"].includes(s)) return "done";
  if (["Preparing", "Out for Delivery", "Rented / Playing", "Waiting for Pickup"].includes(s)) return "running";
  if (["Paid", "DP Paid", "Confirmed"].includes(s)) return "paid";
  return "waiting";
};

export const KIND_LABELS = { booking: "Booking", hold: "Admin Hold", block: "Blokir" };

export const toEvents = (data) => {
  const out = [];
  (data.bookings || []).forEach((b) => {
    out.push({
      key: `b-${b.id}`, kind: "booking", raw: b,
      date: b.rental_date,
      start: parseLocal(b.start_datetime), end: parseLocal(b.inventory_block_until || b.end_datetime),
      tone: bookingTone(b.booking_status),
      title: `${b.start_time || hhmm(parseLocal(b.start_datetime))} · ${b.customer_name || "—"}`,
      sub: `${b.booking_code || ""} · ${b.quantity || 1} meja · ${b.package_name_snapshot || ""}`,
      badge: b.booking_status, qty: b.quantity || 1,
      units: b.assigned_units || [], link: `/admin/bookings/${b.id}`,
      manual: b.booking_source === "admin_manual",
      custom: b.pricing_mode === "custom_event",
    });
  });
  (data.locks || []).forEach((l) => {
    const hold = l.lock_type === "admin_hold";
    out.push({
      key: `l-${l.id}`, kind: hold ? "hold" : "block", raw: l,
      date: l.rental_date,
      start: parseLocal(l.start_datetime), end: parseLocal(l.inventory_block_until || l.end_datetime),
      tone: hold ? "hold" : "block",
      title: `${l.all_day ? "Sehari penuh" : l.start_time} · ${l.title || l.reason}`,
      sub: `${l.quantity || 1} meja · ${(l.unit_codes || []).join(", ") || "otomatis"}`,
      badge: hold ? "Hold" : "Blokir", qty: l.quantity || 1,
      units: l.assigned_units || [], link: null,
    });
  });
  return out.sort((a, b) => a.start - b.start);
};

export const overlapsDay = (ev, dayIso) => {
  const s = parseLocal(`${dayIso}T00:00:00`);
  const e = addDays(s, 1);
  return ev.start < e && ev.end > s;
};
